import { httpClient } from "../http/httpClient";

export type CommissionValue = {
  value: number;
  commission: number;
};

export type Commission = {
  _id: string;
  tableCode: string;
  name: string;
  valuesAndCommissions: CommissionValue[];
  bonus: number;
  order: number;
  type: string;
  isActive: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  limit: number | null;
  percents: number;
};

export type GenerateOffersRequest = {
  valor: number;
  prazo: number;
  renda?: number;
  customerId: string;
};

export type Despesa = {
  valor_padrao_mutavel: boolean;
  codigo: number;
  grupo: string;
  financiada: boolean;
  tipo: number;
  inclusa: boolean;
  numero_item: number;
  obrigatoria: boolean;
  valor_calculado: number;
  valor_maximo: number;
  valor_minimo: number;
};

export type CondicaoCredito = {
  sucesso: boolean;
  mensagem_erro: string;
  prazo: number;
  metodo: string;
  codigo_tabela_financiamento: string;
  descricao_tabela_financiamento: string;
  codigo_produto: string;
  descricao_produto: string;
  primeiro_vencimento: string;
  ultimo_vencimento: string;
  despesas: Despesa[];
  taxa_apropriacao_anual: number;
  taxa_apropriacao_mensal: number;
  taxa_cet_anual: number;
  taxa_cet_mensal: number;
  taxa_referencia_anual: number;
  taxa_referencia_mensal: number;
  valor_bruto: number;
  valor_cliente: number;
  valor_financiado: number;
  valor_solicitado: number;
  valor_iof: number;
  valor_liquido: number;
  valor_parcela: number;
  refinanciamentos: any[];
  parcelas: string[];
};

export type GenerateOffersResponse = {
  hasConditions: boolean;
  conditions: CondicaoCredito[];
  commission: Commission;
};

export async function generateOffers(
  id: string,
  payload: GenerateOffersRequest,
): Promise<GenerateOffersResponse> {
  const { data } = await httpClient
    .post<GenerateOffersResponse>(`/pan/${id}/simulate`, payload)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
